import styled from 'styled-components';

export const VppFooterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 8px 16px;
    background: #f4f4f4;
    border-top: 1px solid #b2b2b2;
    position: fixed;
    right: 0;
    bottom: 0;
    width: 95vw;
    z-index: 2;

    & button {
        margin-left: 16px;
    }
`;
